import angular from 'angular';
import { selectors as deviceSelectors } from '../../../modules/devices';
import template from './patient-photo-capture-notification.html';
import './patient-photo-capture-notification.scss';
class PatientPhotoCaptureNotificationController {
    constructor($ngRedux) {
        this.$ngRedux = $ngRedux;
        this.unsubscribeFromStore = this.$ngRedux.connect(this.mapStateToThis.bind(this))(this);
    }
    get isEnabled() {
        const isEnabledOnCheckInStep = (this.isWelcomeStep && this.hasMediaAccess) || this.isAccessStep;
        if (this.currentInstitution?.institutionAccess) {
            return ([null, true].includes(this.currentInstitution.institutionAccess
                .roomFeatures_patientPhotoatCheckIn) && isEnabledOnCheckInStep);
        }
        return ([null, true].includes(this.room.checkInPhotoCapture) &&
            isEnabledOnCheckInStep);
    }
    get isWelcomeStep() {
        return this.currentStep === 'fillNameStep';
    }
    get isAccessStep() {
        return ['enableCameraStep', 'continueWithoutCameraStep'].includes(this.currentStep);
    }
    get providerName() {
        return this.room.getDisplayName();
    }
    mapStateToThis(state) {
        return {
            hasMediaAccess: deviceSelectors.selectMediaAccessability(state),
        };
    }
    $onDestroy() {
        this.unsubscribeFromStore();
    }
}
const patientPhotoCaptureNotification = {
    template,
    bindings: {
        room: '<',
        currentInstitution: '<',
        currentStep: '<',
    },
    controller: PatientPhotoCaptureNotificationController,
};
export default angular
    .module('doxy.patient.modal.patientPhotoCaptureNotification', [])
    .component('patientPhotoCaptureNotification', patientPhotoCaptureNotification)
    .name;
